/**
 * Generates a button targeted for mobile users that will display the data view.
 * It automatically hides if data view should not be shown.
 */
(function (window) {
  /**
   * Turns on and off the store locator
   * @param {boolean} isVisible If true will set locator visible
   */
  var setLocatorVisibility = function (isVisible) {
    BatchGeoStore.dispatch({
      type: "STORE_LOCATOR_VISIBILITY",
      visibility: isVisible,
    });
  };

  /**
   * Turns on and off the table view
   * @param {boolean} isVisible If true will set table visible
   */
  var setTableVisibility = function (isVisible) {
    var table = isVisible ? "FEATURE_ENABLE" : "FEATURE_DISABLE";
    BatchGeoStore.dispatch([
      { type: "TABLE_MAP_VISIBILITY", visibility: isVisible },
      { type: table, feature: "shouldRenderTable" },
    ]);
  };

  /**
   * Hides data view or store locator based on mode to show the map
   * @param {boolean} isStoreLocatorModeOn - whether or not we are in store locator mode
   * @param {boolean} visibility - the visibility status to set the data or locator view
   */
  var setDataOrLocatorViewVisibility = function (
    isStoreLocatorModeOn,
    visibility,
  ) {
    if (isStoreLocatorModeOn) {
      setLocatorVisibility(visibility);
    } else {
      setTableVisibility(visibility);
    }
  };

  /**
   * If there's a current marker open this will close it and then trigger info
   * window closures.
   */
  var closeInfoWindow = function () {
    var currentMarker = BatchGeoStore.getState().MobileInfoWindow.marker;
    if (currentMarker) {
      BatchGeoStore.dispatch({ type: "MOBILE_INFOWINDOW_CLOSE" });
      BatchGeoStore.dispatch({
        type: "MAPSMARKERS_MANAGER_INFOWINDOW_CLOSE_VIA_X",
      });
    }
  };

  /**
   * MobileDataViewButton sets up the button toggles as explained up top. It
   * has 2 options if you want to add classes to buttons when toggling.
   *
   * @example
   * $('.buttonWrapper').append(BatchGeoUi.MobileDataViewButton({
   *   dataButtonStitcher: function () {
   *     return $('.dataButton');
   *   },
   *   mapButtonStitcher: function () {
   *     return $('.dataButton');
   *   }
   * }));
   *
   * @param {Object} [options] An options hash
   * @param {function} [options.dataButtonStitcher] A function set by the user
   * that returns a jQuery object of the element you want to use for the data
   * view button.
   * @param {function} [options.mapButtonStitcher] A function set by the user
   * that returns a jQuery object of the element you want to use for the map
   * view button.
   * @return {jQuery}
   * @constructor
   */
  BatchGeoUi.MobileDataViewButton = function (options) {
    var self = this;

    var appState = BatchGeoStore.getState().App;
    var mapAndData = appState.mapRenderMethod === 0;
    var isStoreLocatorModeOn = appState.mapMode === "store_locator";

    this.options = $.extend(
      true,
      {},
      {
        // Defaults to empty functions so that we don't need to check for
        // them later on
        dataButtonStitcher: function () {},
        mapButtonStitcher: function () {},
      },
      options,
    );

    var $dataButton = $("<a />", {
      class: "toolbar-icon-table",
      toggle: mapAndData,
      click: function () {
        setDataOrLocatorViewVisibility(isStoreLocatorModeOn, true);
        // When we click the data view button (only exists on mobile)
        // we always want our current infowindow to go away
        closeInfoWindow();
      },
    });

    var $mapButton = $("<a />", {
      class: "toolbar-icon-map active",
      toggle: mapAndData,
      click: function () {
        setDataOrLocatorViewVisibility(isStoreLocatorModeOn, false);
        // Going back to map from table seems to need this, but the
        // store locator doesn't seem to, adding it for safety
        window.batchGeoMap.bgSize(true);
      },
    });

    var buttonWrapClass = mapAndData
      ? "toggle-mobile-data-view-map-data-buttons"
      : "toggle-mobile-data-view-no-buttons";

    // Simply toggles the current button active class when visibility is toggled in store
    var toggleActiveClass = function (newState) {
      self.options
        .dataButtonStitcher()
        .toggleClass("active", newState.visibility);
      self.options
        .mapButtonStitcher()
        .toggleClass("active", !newState.visibility);
    };

    // Add listeners to change active state for buttons
    BatchGeoStore.addListener("StoreLocator", "visibility", toggleActiveClass);
    BatchGeoStore.addListener(
      "BatchGeoTableMap",
      "visibility",
      toggleActiveClass,
    );

    return $("<div />", {
      html: [$mapButton, $dataButton],
      class: "toggle-mobile-data-view " + buttonWrapClass,
    });
  };
})(window);
